<template>
  <div style="width:100%;height:100%">
    <VueOfficeDocx
        v-if="type==='docx'"
        :key="'docx-' + src"
        :src="src"
        @loaded="$emit('loaded')"
        @error="$emit('error')"
    />

    <VueOfficeExcel
        v-else-if="type==='xlsx'"
        :key="'xlsx-' + src"
        :src="src"
        @loaded="$emit('loaded')"
        @error="$emit('error')"
    />

    <VueOfficePdf
        v-else-if="type==='pdf'"
        :key="'pdf-' + src"
        :src="src"
        @loaded="$emit('loaded')"
        @error="$emit('error')"
    />

  </div>
</template>


<script>
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import VueOfficePdf from '@vue-office/pdf'

export default {
  props: {
    src: String,
    type: String
  },
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf
  },
  computed: {
    currentComponent() {
      switch (this.type) {
        case 'docx': return VueOfficeDocx
        case 'xlsx': return VueOfficeExcel
        case 'pdf': return VueOfficePdf
        default: return null
      }
    }
  }
}
</script>